import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseControlValueAccessor } from '../../form-fields/base_control_value_accessor/base';
@Component({
  selector: 'logzy-img-loader',
  templateUrl: './img-loader.component.html',
  styleUrls: ['./img-loader.component.scss']
})
export class ImgLoaderComponent extends BaseControlValueAccessor implements OnInit {

  shim: boolean = true;
  @Input()
  initial: boolean = false;
  // updateUrl(a: any) {
  //   console.log(a.type);
  //   if (a.type == "error") {
  //     this.shim = true;
  //   }
  // }
  errorImg(a: any) {
    this.src = 'assets/images/icons/error.svg'
    if (this.profilePic)
      this.initial = true;
  }
  @Input() src: string = "";
  @Input() profilePic: boolean = false;
  @Input() initials: string = "";
  @Input() border_radius: string = "0px";
  @Input() background_color: string = "#ffffff";
  @Input() span_color: string = "#00000096";
  @Input() fontSize: string = "14px";
  constructor() {
    super();
  }

  ngOnInit(): void {
  }
}
